import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IExcelAnnouncementPopup } from '../commonModels/models'

/**
 * Excel ile yüklenen bayi bazlı duyurunun ana sayfa popup'ı.
 * Bayi kimliği sunucuda oturumdan çözülür; istemci bayi kodu göndermez.
 */
export class ExcelAnnouncementPopupApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/ExcelAnnouncementPopup',
      requesterInfo,
    })
  }

  public async getPopup(): Promise<IExcelAnnouncementPopup> {
    this.props.url = 'homepage/ExcelAnnouncementPopup'
    return await this.getAsync<IExcelAnnouncementPopup>()
  }

  /** Gösterildi/kapatıldı kaydı; popup tekrar modunun dayanağı. */
  public async markSeen(announcementId: number): Promise<boolean> {
    this.props.url = `homepage/ExcelAnnouncementPopupSeen/${announcementId}`
    return await this.postAsync<boolean>()
  }
}
